import { apiClient } from '../utils/apiClient';
export const featureFlagService = {
    get: (key) => apiClient.get(`/feature-flags?key=${key}`),
    set: (key, enabled) => apiClient.post('/feature-flags', { key, enabled }),
    createLabel: (body) => apiClient.post('/ifs-create-label', body),
};
